import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { validateConfig } from '@angular/router/src/config';

declare var toastr;

@Component({
  selector: 'app-user-perfil',
  templateUrl: './user-perfil.component.html',
  styles: [
  ]
})
export class UserPerfilComponent implements OnInit {
  user: any = {};
  roles: any = [];
  rol_id_Aux: number = 0;
  gestion_id: number = 0;
  constructor(private router: Router, private _gs: GeneralService) {
    this.user = JSON.parse(localStorage.getItem('u'));
    let g = JSON.parse(localStorage.getItem('g'));
    this.gestion_id = g;
    this._gs.getDatosUsuarioById(this.user.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.roles = result.data.roles;
          this.user = result.data;
          this.rol_id_Aux = result.data.rol_id;
        }
        else { this.user = {}; }
      });
  }

  ngOnInit() {
  }


  savePass() {
    if (this.valid()) {
      this._gs.postUserUpdatePass(this.user).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.router.navigate(['/inicio']);
            toastr.success('Contraseña actualizada exitosamente.');
          }
        });
    }
  }

  valid() {
    let res = true;
    if ((this.user.rol_id) && this.user.password2) {
      if (this.user.password.toString().trim().length < 6) {
        res = false;
        toastr.warning('Ingrese una contraseña que tenga al menos 6 caracteres.');
      }
      if (this.user.password != this.user.password2) {
        res = false;
        toastr.warning('Las contraseñas no coinciden...');
      }
    }
    else {
      res = false;
    }
    return res;
  }

  changeRol() {
    if (this.rol_id_Aux != this.user.rol_id) {      
      this._gs.postPerfilUsuario(this.user).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            localStorage.removeItem('g');
            localStorage.removeItem('u');

            localStorage.setItem('u', JSON.stringify(result.data));
            localStorage.setItem('g', result.data.gestion);
            toastr.success('Modificación de perfil de trabajo exitoso, el perfil actual es');
            setTimeout(() => {
              window.location.href = '/';
            }, 600);
          } else {
            toastr.warning('No se pudo actualizar el perfil elija correctamente el perfil...')
          }
        },
        error => { console.log('Error', error); });
    }
    else {
      toastr.warning('Debe seleccionar un Rol diferente al actual');
    }
  }

}
